import { FIELD_TYPES } from "./fieldTypes";

export const LIMIT_FIELDS = {
  brandId: FIELD_TYPES.integer,
  dataSpeedGen: FIELD_TYPES.integer,
  offerExtraId: FIELD_TYPES.integer,
  phoneId: FIELD_TYPES.integer,
  phoneOperatingSystemId: FIELD_TYPES.integer,
  phoneVariantEan: FIELD_TYPES.string,
  phoneVariantId: FIELD_TYPES.integer,
  providerId: FIELD_TYPES.integer,
  shopId: FIELD_TYPES.integer,
  sponsoredPositionId: FIELD_TYPES.integer
};
